import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    navIsHidden: false,
    navIsNone: false,
    navIsTransparent: false,
    navIsDark: false,
    isAuth: false,
    activeUser: null,
    snackbarOptions: null
  },
  mutations: {
    navSetHidden (state:any, hidden:boolean) {
      state.navIsTransparent = hidden
    },
    navSetNone (state:any, none:boolean) {
      state.navIsNone = none
    },
    navSetTransparent (state:any, transparent:boolean) {
      state.navIsTransparent = transparent
    },
    navSetDark (state:any, dark:boolean) {
      state.navIsDark = dark
    },
    authLogIn (state:any) {
      state.isAuth = true
    },
    authLogOut (state:any) {
      state.isAuth = false
    },
    setActiveUser (state:any, user:any) {
      state.activeUser = user
    },
    setsnackbarOptions (state:any, snackbarOptions:any) {
      state.snackbarOptions = snackbarOptions
    }
  },
  actions: {
    navSetHidden ({ commit, state }:any, hidden:boolean) {
      commit('navSetHidden', hidden)
    },
    navSetNone ({ commit, state }:any, none:boolean) {
      commit('navSetNone', none)
    },
    navSetTransparent ({ commit, state }:any, transparent:boolean) {
      commit('navSetTransparent', transparent)
    },
    navSetDark ({ commit, state }:any, dark:boolean) {
      commit('navSetDark', dark)
    },
    authLogIn ({ commit, state }:any, user:any) {
      commit('authLogIn')
      commit('setActiveUser', user)
    },
    authLogOut ({ commit, state }:any) {
      commit('authLogOut', false)
      commit('setActiveUser', null)
    },
    setsnackbarOptions ({ commit, state }:any, snackbarOptions:any) {
      commit('setsnackbarOptions', snackbarOptions)
    }
  }
})

export { store as default }
